/**
 * Better Auth client for the frontend.
 *
 * Handles sign-in, sign-up, sign-out, session management via httpOnly cookies.
 * No localStorage tokens needed.
 */
import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields, twoFactorClient } from 'better-auth/client/plugins';
import { config } from './config';

export const authClient = createAuthClient({
  baseURL: config.apiUrl,
  basePath: '/api/auth',
  plugins: [
    inferAdditionalFields({
      user: {
        organization_name: { type: 'string', required: false },
      },
    }),
    twoFactorClient({
      onTwoFactorRedirect: () => {
        window.location.href = '/login/verify-2fa';
      },
    }),
  ],
});
